import { createFileRoute } from '@tanstack/react-router';
import { SecurityTab } from '@/features/account-settings/tabs/security';

export const Route = createFileRoute('/_authenticated/account-settings/security')({
    head: () => ({ meta: [{ title: 'Security | promote.fun' }] }),
    component: SecurityTab,
});
